import React from 'react';
import propTypes from 'prop-types';
import { Alert, Typography } from '@mui/material';

export default function SuncareTrainingNotice({ userEmail }) {
  const inboxLabel = userEmail
    ? `your inbox (${userEmail})`
    : 'your email inbox';

  return (
    <Alert severity='info' sx={{ width: '100%' }}>
      <Typography variant='body2' fontWeight='bold' gutterBottom>
        Contract executed — training required
      </Typography>
      <Typography variant='body2' component='div' gutterBottom>
        Your Suncare contract has been fully executed. Step-by-step LMS training
        instructions were sent to {inboxLabel} with the subject{' '}
        <strong>Suncare - Training Accounts</strong>.
      </Typography>
      <Typography variant='body2' component='div' sx={{ mt: 1 }}>
        In that email you will find:
      </Typography>
      <Typography
        component='ul'
        variant='body2'
        sx={{ mt: 0.5, pl: 2.5, mb: 1 }}
      >
        <li>How to accept your LMS invitation and create your training account</li>
        <li>A link to access the LMS training</li>
        <li>
          A form to upload your LMS certificate after completing the training
        </li>
      </Typography>
      <Typography variant='body2'>
        Please check that email and complete the training and certificate upload
        there. Certificate upload is not available in this portal.
      </Typography>
    </Alert>
  );
}

SuncareTrainingNotice.propTypes = {
  userEmail: propTypes.string
};
